import Groq from 'groq-sdk';

const apiKey = process.env.REACT_APP_GROQ_API_KEY;

console.log('=== GROQ CLIENT DEBUG ===');
console.log('API Key present:', !!apiKey);
console.log('API Key length:', apiKey?.length);
console.log('First 10 chars:', apiKey?.substring(0, 10));
console.log('========================');

if (!apiKey) {
  alert('⚠️ API Key is missing! Check your .env file and restart the server.');
  throw new Error('REACT_APP_GROQ_API_KEY is not defined in environment variables');
}

const groq = new Groq({
  apiKey: apiKey,
  dangerouslyAllowBrowser: true,
});

export const generateContent = async (formData) => {
  const systemPrompt = `You are a Medical Content Generation AI for Indian doctors.

RULES:
1. Follow Indian Medical Council Regulations, 2002
2. Educational content only - NO promotional language
3. NEVER use: "best", "guaranteed", "100% cure", "miracle", "#1"
4. Always add disclaimer at end

OUTPUT FORMAT:
For each platform, provide:
**[Platform Name]**
[Content with emojis]
[Hashtags if applicable]

CONTENT LENGTH:
- Instagram/Facebook: 120-150 words
- WhatsApp: 60-80 words, bullets
- LinkedIn: 150-200 words, professional
- Email: Subject line + 100 words
- YouTube: 30-40 second script`;

  const userPrompt = `Generate ${formData.contentType} for:
Doctor: Dr. ${formData.doctorName}
Speciality: ${formData.speciality}
City: ${formData.city}
Platforms: ${formData.platforms.join(', ')}
Language: ${formData.language}
Month: ${new Date().toLocaleString('default', { month: 'long' })} 2026

Make it India-relevant with ${formData.city} context.`;

  try {
    console.log('📡 Calling Groq API with model: llama-3.3-70b-versatile');
    
    const response = await groq.chat.completions.create({
      messages: [
        { role: 'system', content: systemPrompt },
        { role: 'user', content: userPrompt }
      ],
      model: 'llama-3.3-70b-versatile',  // ✅ UPDATED MODEL
      temperature: 0.7,
      max_tokens: 2000,
    });

    console.log('✅ Content generated successfully!');
    return response.choices[0]?.message?.content || 'Error generating content';
    
  } catch (error) {
    console.error('❌ Groq API Error:', error);
    
    if (error.status === 401) {
      throw new Error('Invalid API key. Please create a new one at console.groq.com');
    } else if (error.status === 429) {
      throw new Error('Rate limit exceeded. Please wait a minute and try again.');
    } else {
      throw new Error(`API Error: ${error.message}`);
    }
  }
};
